import { findDeploymentEnvFromHostName } from './serverEnvService.js';

const findDeploymentEnvFromUrl = () => {
    return findDeploymentEnvFromHostName(window.location.hostname);
};

export { findDeploymentEnvFromUrl };
//# sourceMappingURL=envService.js.map
